import * as React from "react";
import ReactDOM__default from "react-dom";
import useIsomorphicLayoutEffect from "use-isomorphic-layout-effect";
const useHeightAnimation = ({ currentTab, contentRef, contentInnerRef }) => {
  const [height, setHeight] = React.useState("auto");
  const contentHeightRef = React.useRef(0);
  const hasTabChanged = React.useRef(false);
  React.useEffect(() => {
    const element = contentInnerRef.current;
    if (!element) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      const currentElementHeight = element.offsetHeight;
      if (hasTabChanged.current && contentHeightRef.current && contentHeightRef.current !== currentElementHeight) {
        ReactDOM__default.flushSync(() => {
          setHeight(contentHeightRef.current);
        });
        requestAnimationFrame(() => {
          setHeight(currentElementHeight);
        });
      }
      contentHeightRef.current = currentElementHeight;
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
    };
  }, [contentInnerRef]);
  useIsomorphicLayoutEffect(() => {
    if (contentHeightRef.current) {
      hasTabChanged.current = true;
      const timeout = window.setTimeout(() => {
        hasTabChanged.current = false;
      }, 300);
      return () => {
        window.clearTimeout(timeout);
      };
    }
  }, [currentTab]);
  const handleTransitionEnd = React.useCallback(
    (event) => {
      if (event.target === contentRef.current && event.propertyName === "height") {
        setHeight("auto");
        hasTabChanged.current = false;
      }
    },
    [contentRef]
  );
  return {
    handleTransitionEnd,
    contentStyle: height === "auto" ? void 0 : { height },
    wrapperStyle: height === "auto" ? void 0 : { overflowY: "clip" }
  };
};
export {
  useHeightAnimation
};
